"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeFilterToJSON = exports.TimeFilterFromJSONTyped = exports.TimeFilterFromJSON = exports.TimeFilter = void 0;
/**
 * Time period for filtering data. Use \'custom\' with startDate and endDate for custom ranges.
 * @export
 * @enum {string}
 */
var TimeFilter;
(function (TimeFilter) {
    TimeFilter["Day"] = "day";
    TimeFilter["Week"] = "week";
    TimeFilter["Month"] = "month";
    TimeFilter["Year"] = "year";
    TimeFilter["All"] = "all";
    TimeFilter["Custom"] = "custom";
})(TimeFilter = exports.TimeFilter || (exports.TimeFilter = {}));
function TimeFilterFromJSON(json) {
    return TimeFilterFromJSONTyped(json, false);
}
exports.TimeFilterFromJSON = TimeFilterFromJSON;
function TimeFilterFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.TimeFilterFromJSONTyped = TimeFilterFromJSONTyped;
function TimeFilterToJSON(value) {
    return value;
}
exports.TimeFilterToJSON = TimeFilterToJSON;
